import { render, staticRenderFns } from "./ShortcutkeyModal.vue?vue&type=template&id=48ba5024&scoped=true&"
import script from "./ShortcutkeyModal.vue?vue&type=script&lang=js&"
export * from "./ShortcutkeyModal.vue?vue&type=script&lang=js&"
import style0 from "./ShortcutkeyModal.vue?vue&type=style&index=0&id=48ba5024&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ba5024",
  null
  
)

export default component.exports